import React, { useEffect, useState } from 'react';
import { Star, Clock, User, Play, Heart, ChevronRight, ShoppingBag, ShoppingCart, PersonStanding, UserRoundCheck, ClockArrowUp, Video, EllipsisVertical, FolderCheck, LibraryBig, SquareDashedMousePointer, DownloadCloud, Fan, Bookmark, PencilRuler, Paperclip, Bolt, Flame, Sheet, MessageSquareDot, CalendarClock, ChartArea, Info } from 'lucide-react';
import { ChevronLeft } from "lucide-react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import PlayerSideBar from './PlayerSideBar';
import YoutubeDefaultPlayer from '../VideoPlayer/YoutubeDefaultPlayer';
import YoutubeVideoPlayerWebUI from '../VideoPlayer/YoutubeVideoPlayerWebUI';
import VimeoVideoPlayerWebUI from '../VideoPlayer/VimeoVideoPlayerWebUI';
import VimeoDefaultPlayer from '../VideoPlayer/VimeoDefaultPlayer';
import UniversalVideoPlayer from '../VideoPlayer/UniversalVideoPlayerWebUI';
import { playerCard1Object } from './ExportPlayerCard1Object';
import { coursePageObject } from '../CoursePageDesign/ExportCoursePageObject';
import PlayerPageCardSubCourse from './PlayerPageCardSubCourse';

import { useRouteMatch,Switch, Route,Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
 
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import { useParams } from "react-router-dom";
import { SendBackAllQuizDataToClient, SendBackQuizInfoToClient } from '../../store/actions/QuizAPI/createNewMockTest';

/**
 * CourseCard
 * A sleek, responsive course card built with Tailwind CSS.
 * Props:
 *  - course: {
 *      id, title, subtitle, author, duration (e.g. '3h 20m'),
 *      lessons (number), rating (0-5), reviews (number),
 *      image (url), tags: string[], price (string - 'Free' or '₹199'),
 *      progress (0-100) optional
 *    }
 *  - onEnroll(courseId)
 *  - layout: 'compact' | 'regular' (optional)
 *
 * Default export is the component. This file uses Tailwind utility classes.
*/
 import { handleAttemptTestActions } from "../../store/actions/QuizAPI/createNewMockTest";
 


   
export default function PlayerCardQuizItem({}) {


const [ showLeftQueBar, setShowLeftQueBar] = useState(true);
const [ openCurriculum, setOpenCurriculum] = useState(true);
const [ openSubCourse, setOpenSubCourse] = useState(false);
const [ openQnA, setOpenQnA] = useState(false);
const [quizInfo,setQuizInfo] = useState(0);
const [currentItem,setCurrentItem] = useState({});

     const dispatch = useDispatch();
  const {url} =useRouteMatch();
   const {courseId} = useParams();
   const {subCourseId} = useParams();

         const history = useHistory();
                                  
                       
                             
                                const {item} = useParams();
                                const {itemId} = useParams();
                                const {itemToken} = useParams();
                                 function getQuizIdByToken(currentItem, itemId) {
                                  if (!currentItem) return null;
                                
                                  return currentItem?.quizToken === itemId
                                    ? currentItem?.ID
                                
                                    : null;
                                }  
                               const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                                           const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                                          ); 



    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
  
     const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
            
   const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
   const [attemptData, setAttemptData] = useState(null); 
   
     const showSnackbar = () => {
         setSnackbarVisible(true);
       };
       
        const hideSnackbar = () => {
         setSnackbarVisible(false);
       };
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
       {
         
         dispatch({type: "CURSOR",payload:true  });
     
         dispatch({type: "CURSORTEXT",payload:CursorText})
         dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
         dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
       }
        
       const handleMouseLeave = () => {
         
         dispatch({type: "CURSOR",payload:false})
     
         dispatch({type: "CURSORTEXT",payload:""})
     
         dispatch({type: "CURSORTEXTBG",payload:""})
         dispatch({type: "CURSORTEXTCOLOR",payload:""})
       
     
     }
       
       
                const user = useSelector((state)=>state?.user?.user);
       
                        
                        
                                   
                                   
             const [isLockSections, setIsLockSections] = useState();
                                
                               const [animate, setAnimate] = useState(false);
                 
                  const [loader , setLoader] =useState({status:true});
         
             
                  
                       const userData =useSelector((state)=>state?.user?.user);
                      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                      const appId = useSelector((state)=>state?.user?.user?.appId);
                       
  const [itemArr, setItemArr] = useState([]);
   
   
     
        const fireHandleAttemptTestActions=(actionType)=>{
       
      
   
                if(!userEmail) { dispatch({ type: "LoginSignUpPopUp",payload:"login"})}
             let   requestData={};
            
                if(actionType=="startAttempt"){
             requestData={userEmail:userEmail?userEmail:"",
           currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:itemId,
         actionType:"startAttempt"}
            } 
           
            
                    const apiData = dispatch(handleAttemptTestActions(requestData));
                    /* get response as Promise   */
                    apiData.then(response => {
                   
                        history.push(`/player/course/${courseId}/subcourse/${subCourseId}/Quiz/${itemId}/${itemToken}/start`)
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                      
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     
                    });
               } 











                    //   useEffect(()=>{console.log(currentItem)},[])
  // const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (<>  
 <div  style={{padding:"2px",}}>
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
</div>
   
  
   

    
    </>
  );
};

 useEffect(() => {
  
  setTimeout(()=>{
 
     dispatch(
      SendBackQuizInfoToClient({ postId:itemId,userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:""})
    ).then((res) => {
         const quizData= res?.quiz || [];
         console.log(quizData)
         
         setCurrentItem(quizData)
      if (!quizData?.length) return;

     
     
     
    });
  },10)
   
  }, [itemId]);





  return (

    <>  {getQuizIdByToken(currentItem, itemToken)==itemId?
    <div >
      

<div className="sidebarCardChapter">
       
       
     <div className="sidebarLessonCardOuter" >
   
    
    <div >
        <div  style={{position:"relative",display:"flex",justifyContent:"space-between",
        padding:"10px",flexWrap:"wrap",
         borderRadius:"10px",marginTop:"10px",marginBottom:"10px",
                          background:`${playerCard1Object?.lessonCard?.toggeleCardBgColor?.color}`}}>
    <div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
         borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                          background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>
    
                            Total Time : {currentItem?.overallTestTime} Min
                          </div>
    <div style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
         borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                          background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>
                            Total Questions: {currentItem?.count?.total_questions}
                          </div>
                          <div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
         borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                          background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>
                            Total Sections: {currentItem?.count?.total_sections}
                          </div>
                          <div  style={{position:"relative",width:"100px",display:"flex",justifyContent:"space-between",padding:"10px",
         borderRadius:"10px",marginTop:"3px",marginBottom:"3px",fontSize:"10px",
                          background:`${playerCard1Object?.lessonCard?.bgColor?.color}`}}>Attempts: {currentItem?.count?.total_attempts}/{currentItem?.count?.testReAttempts} </div>
                          </div>
         
         <button  onClick={()=>{ fireHandleAttemptTestActions("startAttempt")
        }}> start test</button>
    </div>

         </div>
    
       </div>

   
</div>
:""}
 </>
  );
}
